import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router/';

import API from '@/services/';
import { API_LOGIN, API_SIGNUP } from '@/helpers/config';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    authIn: false,
    authError: null,
  },

  getters: {
    token: state => state.token,
    user: state => state.user,
    isAdmin: state => state.user && state.user.role === 'ADMIN',
  },

  mutations: {
    authStart: (state) => {
      const $state = state;
      $state.authIn = true;
    },

    authStop: (state, errorMessage) => {
      const $state = state;
      $state.authIn = false;
      $state.authError = errorMessage;
    },

    updateToken: (state, token) => {
      const $state = state;
      $state.token = token;
    },

    updateUser: (state, user) => {
      const $state = state;
      $state.user = user;
    },
  },

  actions: {
    doLogin({ commit }, loginData) {
      commit('authStart');

      API.post(API_LOGIN, {
        ...loginData,
      })
        .then((response) => {
          Vue.ls.set('token', response.data.token, 60 * 60 * 6000);
          Vue.ls.set('user', response.data.user, 60 * 60 * 6000);
          commit('authStop', null);
          commit('updateToken', response.data.token);
          commit('updateUser', response.data.user);
          router.push('/');
        })
        .catch(() => {
          commit('authStop', 'error');
          commit('updateToken', null);
          commit('updateUser', null);
        });
    },

    doSignUp({ commit }, signUpData) {
      commit('authStart');

      API.post(API_SIGNUP, {
        ...signUpData,
      })
        .then((response) => {
          Vue.ls.set('token', response.data.token, 60 * 60 * 6000);
          Vue.ls.set('user', response.data.user, 60 * 60 * 6000);
          commit('authStop', null);
          commit('updateToken', response.data.token);
          commit('updateUser', response.data.user);
          router.push('/');
        })
        .catch(() => {
          commit('authStop', 'error');
          commit('updateToken', null);
          commit('updateUser', null);
        });
    },

    fetchToken({ commit }) {
      commit('updateToken', Vue.ls.get('token'));
      commit('updateUser', Vue.ls.get('user'));
    },
  },
});
